import { SpecialHost } from 'api/admin/models';
import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { EventHostsParamsType } from './types';

export const getSpecialHost = actionsFactories.createGetOneActionsFactory<
  EntityType<SpecialHost>,
  EventHostsParamsType
>()('GET_SPECIAL_HOST_REQUEST', 'GET_SPECIAL_HOST_SUCCESS', 'GET_SPECIAL_HOST_FAILURE', 'GET_SPECIAL_HOST_RESET');
